import React, { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const MouseGlow = () => {
    const cursorX = useMotionValue(-100);
    const cursorY = useMotionValue(-100);

    const springConfig = { damping: 25, stiffness: 120 };
    const cursorXSpring = useSpring(cursorX, springConfig);
    const cursorYSpring = useSpring(cursorY, springConfig);

    useEffect(() => {
        const moveCursor = (e) => {
            cursorX.set(e.clientX - 200); // Center the 400px glow
            cursorY.set(e.clientY - 200);
        };

        window.addEventListener("mousemove", moveCursor);

        return () => {
            window.removeEventListener("mousemove", moveCursor);
        };
    }, [cursorX, cursorY]);

    return (
        <motion.div
            style={{
                translateX: cursorXSpring,
                translateY: cursorYSpring,
                position: "fixed",
                top: 0,
                left: 0,
                width: 400,
                height: 400,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(79, 172, 254, 0.15) 0%, rgba(0, 0, 0, 0) 60%)",
                pointerEvents: "none",
                zIndex: 9999,
                mixBlendMode: "screen",
            }}
        />
    );
};

export default MouseGlow;
